export const NAV_ITEMS = [
  { path: '/command', label: 'Command', shortcut: 'C', icon: '◈' },
  { path: '/world', label: 'World', shortcut: 'W', icon: '◎' },
  { path: '/markets', label: 'Markets', shortcut: 'M', icon: '◫' },
  { path: '/capital', label: 'Capital', shortcut: 'K', icon: '◇' },
  { path: '/securities/acm', label: 'Securities', shortcut: 'S', icon: '▣' },
  { path: '/portfolio', label: 'Portfolio', shortcut: 'P', icon: '◉' },
  { path: '/theses', label: 'Theses', shortcut: 'T', icon: '◧' },
  { path: '/learn', label: 'Learn', shortcut: 'L', icon: '◐' },
  { path: '/glossary', label: 'Glossary', shortcut: 'B', icon: '◌' },
  { path: '/library', label: 'Library', shortcut: 'R', icon: '◫' },
  { path: '/operations', label: 'Operations', shortcut: 'O', icon: '◆' },
  { path: '/settings', label: 'Settings', shortcut: ',', icon: '⚙' },
  ...(import.meta.env.DEV
    ? [{ path: '/design-system', label: 'Design System', shortcut: 'D', icon: '⌗' }]
    : []),
] as const;

export const ROUTE_CHORDS: Record<string, string> = {
  C: '/command',
  W: '/world',
  M: '/markets',
  S: '/securities/acm',
  P: '/portfolio',
  T: '/theses',
  L: '/learn',
  O: '/operations',
};
